import { Roles } from 'roles';
import {
	Sidebar,
	SidebarNav,
	SidebarNavItem,
	LoremIpsum,
	Grid,
	Row,
	Col,
	Icon,
} from '@sketchpixy/rubix';
import { withRouter } from 'react-router';
import React from 'react';

import { Meteor } from 'meteor/meteor';

@withRouter
class ApplicationSidebar extends React.Component {
	handleChange(e) {
		this._nav.search(e.target.value);
	}

	render() {
		return (
			<div>
				<Grid>
					<Row>
						<Col xs={12}>
							<div className='sidebar-nav-container'>
								<SidebarNav style={{marginBottom: 0}} ref={(c) => this._nav = c}>

									<SidebarNavItem glyph='icon-fontello-home'          name='Home'             href='/' />

									<SidebarNavItem glyph='icon-fontello-user'          name='Mon compte'       href='/account' />

									<SidebarNavItem glyph='icon-fontello-paper-plane'   name='Mes vols'         href='/my-flights'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'my-flights.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-clock'      name='Planning'       href='/planning'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'calendar.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-calendar'      name='Calendrier'       href='/calendrier2'
										hidden={(!Roles.userHasPermission(Meteor.userId(), 'calendar.list'))}
									/>

									<SidebarNavItem glyph='icon-fontello-calendar'      name='Calendrier'       href='/calendrier'
										hidden={(!Meteor.user().profile.accessToCalendar)}
									/>

									<SidebarNavItem glyph='icon-fontello-ticket'        name='Réservation'      href='/reservations' aliases={['/reservations-add', '/reservations/:id']}
										hidden={!Roles.userHasPermission(Meteor.userId(), 'orders.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-plane'         name='Vols / Tarifs'             href='/flights' aliases={['/flights-add', '/flights/:id']}
										hidden={!Roles.userHasPermission(Meteor.userId(), 'flights.insert')}
									/>

									<SidebarNavItem glyph='icon-fontello-barcode'       name='Promotions'       href='/promotions' aliases={['/promotions-add', '/promotions/:id']}
										hidden={!Roles.userHasPermission(Meteor.userId(), 'promotions.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-cog-alt'       name='Options'          href='/options' aliases={['/options-add', '/options/:id']}
										hidden={!Roles.userHasPermission(Meteor.userId(), 'options.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-users'         name='Utilisateurs'     href='/users'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'users.list')}
									/>


									<SidebarNavItem glyph='icon-fontello-smile'         name='Partenaires'     href='/partners'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'users.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-money'         name='Factures groupées'     href='/group-bills'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'users.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-cloud-sun-inv' name='Montgolfieres'    href='/montgolfieres'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'montgolfieres.insert')}
									/>

									<SidebarNavItem glyph='icon-fontello-location'      name='Lieux envols'     href='/places'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'places.list')}
									/>


									<SidebarNavItem glyph='icon-fontello-rss'           name='Alertes'          href='/alerts'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'alerts.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-chart-pie'     name='Statistiques'     href='/statistiques'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'statistics.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-export'     name='SMS'     href='/sms'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'planifications.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-pin'			name='Planifications'    href='/planifications'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'planifications.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-export'			name='Exports'    href='/exports'
										hidden={!Roles.userHasPermission(Meteor.userId(), 'planifications.list')}
									/>

									<SidebarNavItem glyph='icon-fontello-email'			name='Nous contacter'    href='/contact'
									/>

								</SidebarNav>
							</div>
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

@withRouter
export default class SidebarContainer extends React.Component {
	render() {
		return (
			<div id='sidebar'>
				<div id='avatar'>
					<Grid>
						<Row className='fg-white'>
							<Col xs={4} collapseRight>
								<Icon glyph='icon-fontello-user' style={{background: '#fff', color: '#FA7252', fontSize: '43px', lineHeight: '100%', width: '40px', height: '40px', display: 'inline-block', textAlign: 'center', marginTop: '17px', borderRadius: '100%'}} />
							</Col>
							<Col xs={8} collapseLeft id='avatar-col'>
								<div style={{top: 30, left: 3, fontSize: 16, lineHeight: 1, position: 'relative'}}>{ Meteor.user().username }</div>
							</Col>
						</Row>
					</Grid>
				</div>
				<div id='sidebar-container'>
					<Sidebar sidebar={0}>
						<ApplicationSidebar />
					</Sidebar>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/layout/sidebar.js
 **/